export const categories = [
  { id: 1, name: '热血', slug: 'rexue', icon: 'ri-fire-line', count: 128 },
  { id: 2, name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', count: 96 },
  { id: 3, name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 87 },
  { id: 4, name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 64 },
  { id: 5, name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', count: 73 },
  { id: 6, name: '校园', slug: 'xiaoyuan', icon: 'ri-building-line', count: 55 },
  { id: 7, name: '都市', slug: 'dushi', icon: 'ri-building-2-line', count: 82 },
  { id: 8, name: '古风', slug: 'gufeng', icon: 'ri-archive-line', count: 41 },
];

export const hotComics = [
  {
    id: 1,
    title: '伪装学渣',
    author: '木瓜黄',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20art%20featuring%20two%20high%20school%20boys%20in%20school%20uniforms%2C%20one%20with%20glasses%20looking%20studious%2C%20the%20other%20looking%20rebellious%2C%20warm%20lighting%2C%20soft%20pastel%20colors%2C%20manga%20style%20illustration%2C%20clean%20white%20background%2C%20anime%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '校园',
    categorySlug: 'xiaoyuan',
    rating: 9.6,
    views: '1280万',
    status: '连载中',
    description: '这是一个关于两个伪装学霸的高中生，互相在学习和生活中较劲又互相成长的青春校园故事。',
    chapters: 156,
    updateTime: '2小时前',
  },
  {
    id: 2,
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20young%20martial%20artist%20with%20flame%20aura%20surrounding%20him%2C%20fantasy%20cultivation%20theme%2C%20dramatic%20lighting%2C%20epic%20fantasy%20art%20style%2C%20clean%20composition%2C%20anime%20style%20illustration&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    rating: 9.5,
    views: '3560万',
    status: '连载中',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望时，一缕灵魂从他的戒指中浮现...',
    chapters: 428,
    updateTime: '5小时前',
  },
  {
    id: 3,
    title: '偷偷藏不住',
    author: '竹已',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20cover%20featuring%20a%20beautiful%20girl%20and%20a%20handsome%20boy%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20tones%2C%20youth%20romance%20theme%2C%20delicate%20manga%20art%20style%2C%20clean%20white%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    rating: 9.3,
    views: '2120万',
    status: '已完结',
    description: '十三岁那年，桑稚偷偷喜欢上一个男人。男人的模样冷淡寡言，却温柔到了骨子里。',
    chapters: 87,
    updateTime: '1天前',
  },
  {
    id: 4,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20young%20man%20with%20supernatural%20energy%20surrounded%20by%20traditional%20Taoist%20symbols%2C%20urban%20fantasy%20theme%2C%20mysterious%20atmosphere%2C%20cool%20color%20tones%2C%20detailed%20manga%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    rating: 9.7,
    views: '4890万',
    status: '连载中',
    description: '随着父亲失踪，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。',
    chapters: 612,
    updateTime: '3小时前',
  },
  {
    id: 5,
    title: '天官赐福',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20a%20celestial%20being%20in%20flowing%20white%20robes%20with%20flower%20petals%20floating%2C%20ancient%20Chinese%20fantasy%20theme%2C%20ethereal%20lighting%2C%20elegant%20art%20style%2C%20clean%20soft%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '古风',
    categorySlug: 'gufeng',
    rating: 9.8,
    views: '6230万',
    status: '连载中',
    description: '八百年前，谢怜是金枝玉叶的太子殿下，风光无限的天之骄子。八百年后，谢怜成了三界笑柄。',
    chapters: 201,
    updateTime: '6小时前',
  },
  {
    id: 6,
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20cool%20male%20esports%20player%20with%20gaming%20headset%2C%20futuristic%20gaming%20theme%2C%20dynamic%20action%20pose%2C%20vibrant%20colors%2C%20modern%20anime%20art%20style%2C%20clean%20white%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    rating: 9.5,
    views: '5120万',
    status: '已完结',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐...',
    chapters: 172,
    updateTime: '2天前',
  },
  {
    id: 7,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20cute%20fox%20spirit%20girl%20with%20red%20hair%20and%20traditional%20Chinese%20dress%2C%20romantic%20fantasy%20theme%2C%20warm%20golden%20lighting%2C%20charming%20anime%20art%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    rating: 9.4,
    views: '3780万',
    status: '连载中',
    description: '根据古典小说记载，世上有人有妖，妖会与人相恋，妖寿命千万年，人寿命有限...',
    chapters: 289,
    updateTime: '8小时前',
  },
  {
    id: 8,
    title: '魔道祖师',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20handsome%20man%20in%20black%20robes%20playing%20a%20flute%2C%20dark%20cultivation%20fantasy%20theme%2C%20dramatic%20moonlight%2C%20mysterious%20atmosphere%2C%20detailed%20anime%20art%20style%2C%20clean%20dark%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '古风',
    categorySlug: 'gufeng',
    rating: 9.8,
    views: '7890万',
    status: '已完结',
    description: '夷陵老祖魏无羡死了，万人唾骂，声名狼藉。十三年后，莫玄羽献舍，魏无羡重归于世。',
    chapters: 256,
    updateTime: '1天前',
  },
];

export const latestUpdates = [
  { id: 1, title: '伪装学渣', chapter: '第156话 新的开始', time: '2小时前', categoryName: '校园' },
  { id: 2, title: '一人之下', chapter: '第612话 异人之巅', time: '3小时前', categoryName: '热血' },
  { id: 3, title: '斗破苍穹', chapter: '第428话 丹塔之战', time: '5小时前', categoryName: '热血' },
  { id: 4, title: '天官赐福', chapter: '第201话 花城心事', time: '6小时前', categoryName: '古风' },
  { id: 5, title: '狐妖小红娘', chapter: '第289话 前世今生', time: '8小时前', categoryName: '恋爱' },
  { id: 6, title: '镖人', chapter: '第118话 大漠孤烟', time: '10小时前', categoryName: '热血' },
  { id: 7, title: '镇魂街', chapter: '第345话 守护之魂', time: '12小时前', categoryName: '奇幻' },
  { id: 8, title: '哑舍', chapter: '第198话 古董有灵', time: '14小时前', categoryName: '悬疑' },
  { id: 9, title: '星辰变', chapter: '第267话 星辰之力', time: '16小时前', categoryName: '奇幻' },
  { id: 10, title: '少年歌行', chapter: '第156话 江湖再见', time: '18小时前', categoryName: '古风' },
];

export const rankingList = [
  { rank: 1, title: '魔道祖师', author: '墨香铜臭', rating: 9.8, trend: 'up' },
  { rank: 2, title: '一人之下', author: '米二', rating: 9.7, trend: 'up' },
  { rank: 3, title: '伪装学渣', author: '木瓜黄', rating: 9.6, trend: 'up' },
  { rank: 4, title: '天官赐福', author: '墨香铜臭', rating: 9.8, trend: 'stable' },
  { rank: 5, title: '斗破苍穹', author: '天蚕土豆', rating: 9.5, trend: 'down' },
  { rank: 6, title: '全职高手', author: '蝴蝶蓝', rating: 9.5, trend: 'stable' },
  { rank: 7, title: '狐妖小红娘', author: '小新', rating: 9.4, trend: 'up' },
  { rank: 8, title: '偷偷藏不住', author: '竹已', rating: 9.3, trend: 'stable' },
];

export const banners = [
  {
    id: 1,
    title: '伪装学渣',
    subtitle: '年度最受欢迎校园漫画',
    description: '学霸与学渣的身份互换，青春的懵懂与悸动',
    link: '/comic/1',
  },
  {
    id: 2,
    title: '一人之下',
    subtitle: '国漫巅峰之作',
    description: '异人世界的冒险，揭露隐藏在现代都市下的神秘力量',
    link: '/comic/4',
  },
  {
    id: 3,
    title: '天官赐福',
    subtitle: '古风奇幻仙侠大作',
    description: '八百年轮回，花城与谢怜的千古绝恋',
    link: '/comic/5',
  },
];

export const siteInfo = {
  name: '土豪漫画网',
  subtitle: '伪装学渣漫画 - 免费阅读下拉式漫画',
  description: '土豪漫画网让您免费阅读伪装学渣漫画，支持下拉式浏览，界面清爽，操作流畅，随时随地享受漫画带来的快乐。',
  keywords: '伪装学渣漫画,免费阅读,下拉式漫画,土豪漫画网',
  domain: 'tuhaomanhua.com',
  email: 'contact@tuhaomanhua.com',
  qq: '1234567890',
  wechat: 'tuhaomanhua',
  established: '2018',
  totalComics: '5000+',
  totalUsers: '800万+',
  dailyActive: '50万+',
};

export const allComics = [
  ...hotComics,
  {
    id: 9,
    title: '镖人',
    author: '许先哲',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20rugged%20swordsman%20in%20desert%20setting%2C%20martial%20arts%20historical%20theme%2C%20gritty%20ink%20wash%20painting%20style%2C%20dramatic%20contrast%2C%20powerful%20composition&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '热血',
    categorySlug: 'rexue',
    rating: 9.4,
    views: '1560万',
    status: '连载中',
    description: '大业三年，隋王朝在隋炀帝杨广的残暴统治下民不聊生。身手不凡的镖客刀马行走于西域大漠...',
    chapters: 118,
    updateTime: '10小时前',
  },
  {
    id: 10,
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20young%20man%20with%20guardian%20spirit%20behind%20him%2C%20urban%20supernatural%20theme%2C%20dramatic%20lighting%2C%20cool%20dark%20tone%20anime%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    rating: 9.2,
    views: '2340万',
    status: '连载中',
    chapters: 345,
    description: '镇魂街，此乃吸纳亡灵镇压恶灵之地。这是一个人灵共存的世界...',
    updateTime: '12小时前',
  },
  {
    id: 11,
    title: '哑舍',
    author: '玄色',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20antique%20shop%20with%20mysterious%20atmosphere%2C%20ancient%20artifacts%20glowing%2C%20a%20handsome%20shopkeeper%2C%20mystery%20supernatural%20theme%2C%20warm%20amber%20lighting%2C%20detailed%20anime%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    rating: 9.1,
    views: '1890万',
    status: '连载中',
    chapters: 198,
    description: '哑舍里的古物，每一件都有着自己的故事，承载了许多年，无人倾听...',
    updateTime: '14小时前',
  },
  {
    id: 12,
    title: '星辰变',
    author: '我吃西红柿',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20young%20cultivator%20surrounded%20by%20stars%20and%20cosmic%20energy%2C%20fantasy%20cultivation%20theme%2C%20celestial%20vibe%2C%20bright%20ethereal%20lighting%2C%20detailed%20anime%20art%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    rating: 9.3,
    views: '2670万',
    status: '连载中',
    chapters: 267,
    description: '一名孩童，天生无法修炼内功。为了得到父亲的重视，他毅然选择修炼痛苦艰难的外功...',
    updateTime: '16小时前',
  },
  {
    id: 13,
    title: '少年歌行',
    author: '周木楠',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20young%20swordsmen%20in%20traditional%20Chinese%20martial%20arts%20setting%2C%20jianghu%20theme%2C%20flowing%20ink%20style%2C%20elegant%20composition%2C%20warm%20earthy%20tones%2C%20anime%20art&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    category: '古风',
    categorySlug: 'gufeng',
    rating: 9.2,
    views: '1230万',
    status: '连载中',
    chapters: 156,
    description: '寒水寺忘忧大师坐化后，一口黄金棺材的秘密逐渐浮出水面...',
    updateTime: '18小时前',
  },
  {
    id: 14,
    title: '恋与制作人',
    author: '叠纸游戏',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20four%20handsome%20male%20characters%20in%20modern%20fashion%2C%20otome%20romance%20theme%2C%20soft%20pastel%20colors%2C%20elegant%20composition%2C%20beautiful%20anime%20art%20style&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    rating: 9.0,
    views: '980万',
    status: '已完结',
    chapters: 67,
    description: '继承了父亲留下的影视公司后，你遇到了四位身份各异的男主角...',
    updateTime: '3天前',
  },
  {
    id: 15,
    title: '非人哉',
    author: '一汪空气',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20mythological%20creatures%20in%20modern%20office%20setting%2C%20comedy%20slice%20of%20life%20theme%2C%20bright%20cheerful%20colors%2C%20cute%20chibi%20art%20style%2C%20clean%20fun%20composition&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    rating: 9.3,
    views: '3450万',
    status: '连载中',
    chapters: 423,
    description: '中国神话传说中的神仙妖怪们来到现代都市生活的搞笑日常。',
    updateTime: '4小时前',
  },
  {
    id: 16,
    title: '大理寺日志',
    author: 'RC',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20cat-headed%20official%20in%20ancient%20Chinese%20court%20uniform%2C%20historical%20mystery%20comedy%20theme%2C%20warm%20vintage%20tones%2C%20unique%20art%20style%2C%20clean%20composition&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    rating: 9.1,
    views: '1670万',
    status: '连载中',
    chapters: 234,
    description: '唐朝武周年间，洛阳大理寺内，一只白猫被任命为大理寺少卿...',
    updateTime: '7小时前',
  },
];

export const chaptersData: Record<number, { id: number; title: string; time: string }[]> = {
  1: Array.from({ length: 156 }, (_, i) => ({
    id: i + 1,
    title: `第${156 - i}话 ${['新的开始', '期末考试', '图书馆偶遇', '秘密暴露', '约定', '篮球赛', '家长会', '生日惊喜', '误会', '和解'][i % 10]}`,
    time: i < 3 ? `${i + 1}小时前` : `${Math.floor(i / 3) + 1}天前`,
  })),
};

export const faqData = [
  {
    question: '土豪漫画网的漫画都是免费的吗？',
    answer: '是的，土豪漫画网所有漫画均完全免费阅读，无需注册登录，无需付费，打开即看，让每一位漫画爱好者都能轻松享受阅读乐趣。',
  },
  {
    question: '什么是下拉式漫画阅读？',
    answer: '下拉式漫画阅读是一种创新的阅读方式，所有漫画内容在一个页面上连续展示，您只需向下滚动即可流畅阅读，无需频繁点击翻页，让阅读体验更加沉浸自然。',
  },
  {
    question: '伪装学渣漫画多久更新一次？',
    answer: '伪装学渣漫画通常保持每周更新的频率，我们会在第一时间同步最新的漫画章节，确保读者能够及时看到最新内容。具体更新时间请关注网站首页的更新通知。',
  },
  {
    question: '网站支持手机阅读吗？',
    answer: '完全支持！土豪漫画网采用响应式设计，在手机、平板、电脑等任何设备上都能获得最佳的阅读体验，随时随地享受漫画带来的快乐。',
  },
  {
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过首页的分类导航进入对应的分类页面，我们提供了热血、恋爱、搞笑、悬疑、奇幻、校园、都市、古风等多种分类，帮助您快速找到心仪的漫画作品。',
  },
];

export const aboutInfo = {
  brandIntro: '土豪漫画网成立于2018年，是国内领先的免费漫画阅读平台之一。我们致力于为广大漫画爱好者提供优质的在线阅读体验，汇集了海量国产漫画、日本漫画、韩国漫画等资源。平台采用创新的下拉式阅读技术，让漫画阅读更加流畅自然。',
  mission: '让每一个人都能免费享受到漫画带来的快乐与感动，打造最优质的漫画阅读社区。',
  features: [
    { icon: 'ri-book-open-line', title: '海量资源', desc: '5000+部漫画作品，涵盖各类题材' },
    { icon: 'ri-download-cloud-line', title: '完全免费', desc: '无需付费，无需注册，即开即看' },
    { icon: 'ri-smartphone-line', title: '多端适配', desc: '电脑、平板、手机全平台畅读' },
    { icon: 'ri-speed-up-line', title: '加载迅速', desc: 'CDN加速，秒开漫画不等待' },
    { icon: 'ri-shield-check-line', title: '高清画质', desc: '高清晰度漫画图片，细节尽显' },
    { icon: 'ri-user-heart-line', title: '用户体验', desc: '下拉式阅读，沉浸式漫画体验' },
  ],
  contact: {
    email: 'contact@tuhaomanhua.com',
    qq: '1234567890',
    wechat: 'tuhaomanhua',
    address: '中国上海市浦东新区张江高科技园区',
    workingHours: '周一至周日 9:00 - 22:00',
  },
};